<template>
  <div class="pay-order-modal window">
    <detail-header
        :formDataObj="formData"
        :isSubmit="isSubmit"
        :isEdit="true"
        :pcdType="2"
        :isChangeType="isChangeType"
        :isLoaded="isLoaded"
        @payObj="getPayObj"
        @selectComp="selectCompName"
        :isHasDo="true"
        :isOrder="isOrder"
        :isSaleMan="isSaleMan"
        :isAcc="isAcc"
    ></detail-header>
    <div class="pay-modal-main">
      <table-header
          :isAcc="isAcc"
          @add="insertEvent"
          @remove="removeEvent"
          @copy="copyEvent"
          :batch="!isSaleMan"
          :txt="payType === 0 ? infoTxt : ''"
          @batchAdd="openBatchAdd"
      ></table-header>
      <!--STR 线上付款-->
      <div class="add-box clearfix" v-show="payType === 0">
        <vxe-table
            show-overflow
            border
            keep-source
            class="table-style cur-table-style produre"
            ref="xTable"
            max-height="680"
            :data="tableData"
            :enabled="false"
            :edit-rules="editRules"
            :auto-resize="true"
            :edit-config="{ trigger: 'click', mode: 'row', showIcon: false }"
            @cell-click="cellClickEvent"
            @scroll="$refs.xTable.clearValidate()"
            :show-footer="true"
            :footer-method="footerMethod"
            :footer-cell-class-name="footerCellClassName"
        >
          <vxe-table-column width="50" align="center" type="checkbox"></vxe-table-column>

          <vxe-table-column width="60" align="center" field="index" title="序号" v-if="isImport"></vxe-table-column>
          <vxe-table-column type="seq" width="60" align="center" title="序号" v-else></vxe-table-column>
          <vxe-table-column field="ordersNum" width="150" title="关联订单" align="center">
            <template v-slot="{ row }">
              <div v-if="isinitByOrder">
                <em>{{ row.ordersNum }}</em>
              </div>
              <div class="link-text" v-else>
                <span @click="openOrderModal(row)" v-if="!isImport">
                  <em v-if="row.ordersList && row.ordersList.length > 1">查看关联订单</em>
                  <em v-else-if="row.ordersList && row.ordersList.length == 1">{{
                      row.ordersList[0].ordersNum
                    }}</em>
                  <em v-else>选择关联订单</em>
                </span>
                <span @click="openOrderModal(row)" v-else>
                  <em v-if="row.ordersNum">{{ row.ordersNum }}</em>
                  <em v-else>选择关联订单</em>
                </span>
                <img v-if="row.ordersNum"
                     style="height: 10px;width: 10px;cursor: pointer;"
                     src="~assets/images/common/close.png"
                     @click.stop="removeOrder(row)"/>
              </div>
            </template>
          </vxe-table-column>

          <!-- 2020-09-18 新增 所属公司 业务员 客户名称-->
          <!--          <vxe-table-column-->
          <!--              width="200"-->
          <!--              field="compName"-->
          <!--              title="所属方"-->
          <!--              align="center"-->
          <!--              show-overflow-->
          <!--          >-->
          <!--            <template v-slot:header="{ column }">-->
          <!--              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>-->
          <!--            </template>-->
          <!--            <template v-slot="scope">-->
          <!--              <div v-if="isinitByOrder">-->
          <!--                {{ scope.row.compName }}-->
          <!--              </div>-->
          <!--              <div v-else>-->
          <!--                <div v-if="payType === 1">-->
          <!--                  <platform-corp-->
          <!--                      :row="scope.row"-->
          <!--                      :field="'compName'"-->
          <!--                      :placeholder="'请选择平台企业'"-->
          <!--                      @select="$refs.xTable.updateStatus(scope)"-->
          <!--                      @update="selectCompName"-->
          <!--                      :autoSave="false"-->
          <!--                      v-if="canInsert"-->
          <!--                  ></platform-corp>-->
          <!--                  <div v-else>{{ scope.row.compName }}</div>-->
          <!--                </div>-->
          <!--                <div-->
          <!--                    class="link-text"-->
          <!--                    :title="scope.row.compName"-->
          <!--                    @click="openPayAccount(scope.row, 'compName')"-->
          <!--                    v-else-->
          <!--                >-->
          <!--                  {{ scope.row.compName ? scope.row.compName : "选择付款所属方" }}-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </vxe-table-column>-->
          <vxe-table-column field="salesMan" width="105" title="业务员" align="center" show-overflow>
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="scope">
              <div v-if="isinitByOrder || isSaleMan">
                {{ scope.row.salesMan }}
              </div>
              <div v-else>
                <sales-man
                    v-if="canInsert"
                    :row="scope.row"
                    :field="'salesMan'"
                    @setSaleMan="setSaleMan"
                ></sales-man>
              </div>
            </template>
          </vxe-table-column>
          <!-- <vxe-table-column
            field="rateManage"
            width="105"
            title="佣金率(%)"
            align="center"
          >
          </vxe-table-column> -->
          <vxe-table-column field="clientName" width="150" title="客户名称" align="center" show-overflow>
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row }">
              <div v-if="isinitByOrder">{{ row.clientName }}</div>
              <div class="link-text" :title="row.clientName" @click="openChooseAccount(row, 'clientName')" v-else>
                {{ row.clientName ? row.clientName : "选择收款客户" }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="clientName" width="120" title="资金类型" align="center">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row }">
              <vxe-select
                  v-model="row.moneyType"
                  :options="moneyTypeOption"
                  placeholder="请选择"
                  transfer
              ></vxe-select>
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="payAmount" title="金额">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="scope">
              <vxe-input
                  v-model="scope.row.payAmount"
                  v-on:input="inputPayAmountEvent(scope.row)"
                  @input="$refs.xTable.updateStatus(scope)"
                  placeholder="必填"
                  type="number"
              ></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="note" title="摘要">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row }">
              <vxe-input v-model="row.note" placeholder="必填" maxlength="200"></vxe-input>
            </template>
          </vxe-table-column>

          <!-- 承运人 -开始 -->
          <vxe-table-column width="200" field="paymentsName" :title="payType === 0 ? '付款账户' : '付款企业(人)名称'">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row, $rowIndex }">
              <div :title="row.paymentsName" class="link-text"
                   @click="openBankAccountModal(row, $rowIndex, 'paymentsName')">
                {{
                  row.paymentsName == null || row.paymentsName == ""
                      ? payType === 0
                          ? "选择付款账户"
                          : "付款企业(人)银行账户"
                      : row.paymentsName
                }}
              </div>
            </template>
          </vxe-table-column>

          <vxe-table-column width="150" field="payBankOwn" :title="payType === 0 ? '账户所属公司' : '开户行'">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
          </vxe-table-column>
          <vxe-table-column width="220" field="payAccount" title="付款账号">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
          </vxe-table-column>

          <vxe-table-column width="200" field="recName" :title="payType === 0 ? '收款账户' : '收款企业(人)名称'">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row, $rowIndex }">
              <div class="link-text" :title="row.recName" @click="openBankAccountModal(row, $rowIndex, 'recName')">
                {{
                  row.recName == null || row.recName == "" || row.recName == undefined
                      ? payType === 0
                          ? "选择收款账户"
                          : "选择收款企业(人)银行账户"
                      : row.recName
                }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="recBankOwn"
                            :title="payType === 0 ? '账户所属公司' : '开户行'">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
          </vxe-table-column>
          <vxe-table-column width="220" field="recAccount" title="收款账号">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
          </vxe-table-column>
          <!-- 平台跟销售方 结束 -->
          <vxe-table-column field="isDraw" title="自动提现" width="100">
            <template v-slot="{ row, $rowIndex }">
              <vxe-select
                  v-model="row.isDraw"
                  @change="changeIsDraw(row, $rowIndex)"
                  placeholder="请选择"
                  :options="isDrawType"
                  :disabled="payType === 1"
                  transfer
              ></vxe-select>
            </template>
          </vxe-table-column>
          <vxe-table-column field="drawAccount" title="提现银行账号" width="200">
            <template v-slot="{ row, $rowIndex }">
              <div v-if="row.isDraw === 1 && row.recName">
                <vxe-input
                    v-model="row.drawAccount"
                    @blur="checkNum('drawAccount', 30, $rowIndex, $event)"
                    @change="editBankCount($rowIndex, $event)"
                    placeholder="输入提现账号"
                >
                  <template #suffix>
                    <Icon
                        style="color: #2d8cf0; font-size: 20px; cursor: pointer"
                        type="ios-list-box-outline"
                        @click="openBindAccountModal(row, $rowIndex)"
                    />
                  </template>
                </vxe-input>
              </div>
              <div v-else style="background: #f3f3f3; width: 100%; height: 30px">
                <span></span>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="drawBank" title="提现开户银行" width="300">
            <template v-slot:header="{ column }">
              <span class="column-title-em"
              >{{ column.title }}
                <em style="color: #f00" v-if="isShowAccountNewTip">
                  若未查询到，开启手动输入
                </em></span
              >
            </template>
            <template v-slot="{ row, $rowIndex }">
              <div v-if="row.isDraw === 1 && row.recName">
                <span v-if="row.isDrawAccountNew">
                  <vxe-pulldown ref="bankDown" transfer style="width: 100%">
                    <template v-slot>
                      <vxe-input
                          v-model="row.inputDrawBank"
                          @focus="bankFocusEvent(row)"
                          @change="bankKeyupEvent(row, $rowIndex)"
                          @blur="checkDrawOpenOrgNum(row, $rowIndex)"
                          class="switch-input"
                          placeholder="输入开户行"
                      >
                        <template #prefix>
                          <span style="display: none">{{ row.inputDrawBank }}</span>
                        </template>
                        <template #suffix>
                          <i-switch
                              v-model="row.switchVal"
                              @on-change="changeSwitch($rowIndex, $event)"
                              false-color="#AAABAB"
                              size="large"
                          >
                            <span slot="open"></span>
                            <span slot="close"></span>
                          </i-switch>
                        </template>
                      </vxe-input>
                    </template>
                    <template v-slot:dropdown>
                      <div class="my-dropdown1">
                        <div
                            class="list-item1"
                            v-for="item in bankList"
                            :key="item.id"
                            @click="bankSelectEvent(item, $rowIndex)"
                        >
                          <i class="fa fa-user-o"></i>
                          <span>{{ item.orgName }}</span>
                        </div>
                      </div>
                    </template>
                  </vxe-pulldown>
                </span>
                <span v-else>
                  {{ row.drawBank == null || row.drawBank == "" ? "" : row.drawBank }}</span
                >
              </div>
              <div v-else style="background: #f3f3f3; width: 100%; height: 30px">
                <span></span>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="drawOpenOrgNum" title="联行号" width="150">
            <!-- v-if="isShowDrawOpenOrgNum" -->
            <template v-slot="scope">
              <vxe-input
                  v-model="scope.row.drawOpenOrgNum"
                  :disabled="!scope.row.switchVal"
                  :placeholder="!scope.row.switchVal ? '' : '请输入联行号'"
                  @blur="checkNum('drawOpenOrgNum', 12, scope.$rowIndex, $event)"
                  @change="editDrawOpenOrgNum(scope.$rowIndex, $event)"
                  type="number"
              ></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="fileList" title="操作" align="center">
            <template v-slot="{ row }">
              <upload-row :row="row" :initFileList="row.fileList"></upload-row>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <!--STR 线下付款-->
      <div class="add-box clearfix" v-show="payType === 1">
        <vxe-table
            show-overflow
            border
            keep-source
            class="table-style cur-table-style produre"
            ref="xTable1"
            max-height="680"
            :data="tableData"
            :enabled="false"
            :edit-rules="editRules2"
            :auto-resize="true"
            :edit-config="{ trigger: 'click', mode: 'row', showIcon: false }"
            @cell-click="cellClickEvent"
            @scroll="$refs.xTable1.clearValidate()"
            :show-footer="true"
            :footer-method="footerMethod"
            :footer-cell-class-name="footerCellClassName"
        >
          <vxe-table-column width="50" align="center" type="checkbox"></vxe-table-column>

          <vxe-table-column
              width="60"
              align="center"
              field="index"
              title="序号"
              v-if="isImport"
          ></vxe-table-column>
          <vxe-table-column
              type="seq"
              width="60"
              align="center"
              title="序号"
              v-else
          ></vxe-table-column>

          <vxe-table-column field="ordersNum" width="150" title="关联订单" align="center">
            <template v-slot="{ row }">
              <div v-if="isinitByOrder">
                <em>{{ row.ordersNum }}</em>
              </div>
              <div class="link-text" v-else>
                <span @click="openOrderModal(row)" v-if="!isImport">
                  <em v-if="row.ordersList && row.ordersList.length > 1">查看关联订单</em>
                  <em v-else-if="row.ordersList && row.ordersList.length == 1">{{
                      row.ordersList[0].ordersNum
                    }}</em>
                  <em v-else>选择关联订单</em>
                </span>
                <span @click="openOrderModal(row)" v-else>
                  <em v-if="row.ordersNum">{{ row.ordersNum }}</em>
                  <em v-else>选择关联订单</em>
                </span>
              </div>
            </template>
          </vxe-table-column>

          <!-- 2020-09-18 新增 所属公司 业务员 客户名称-->
          <!--          <vxe-table-column-->
          <!--              width="200"-->
          <!--              field="compName"-->
          <!--              title="所属方"-->
          <!--              align="center"-->
          <!--              show-overflow-->
          <!--          >-->
          <!--            <template v-slot:header="{ column }">-->
          <!--              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>-->
          <!--            </template>-->
          <!--            <template v-slot="scope">-->
          <!--              <div v-if="isinitByOrder">-->
          <!--                {{ scope.row.compName }}-->
          <!--              </div>-->
          <!--              <div v-else>-->
          <!--                <div v-if="payType === 1">-->
          <!--                  <platform-corp-->
          <!--                      :row="scope.row"-->
          <!--                      :field="'compName'"-->
          <!--                      :placeholder="'请选择平台企业'"-->
          <!--                      @select="$refs.xTable1.updateStatus(scope)"-->
          <!--                      @update="selectCompName"-->
          <!--                      :autoSave="false"-->
          <!--                      v-if="canInsert"-->
          <!--                  ></platform-corp>-->
          <!--                  <div v-else>{{ scope.row.compName }}</div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </vxe-table-column>-->
          <vxe-table-column field="salesMan" width="105" title="业务员" align="center" show-overflow>
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="scope">
              <div v-if="isinitByOrder">
                {{ scope.row.salesMan }}
              </div>
              <div v-else>
                <sales-man
                    v-if="canInsert"
                    :row="scope.row"
                    :field="'salesMan'"
                    @setSaleMan="setSaleMan"
                ></sales-man>
              </div>
            </template>
          </vxe-table-column>
          <!-- <vxe-table-column
            field="rateManage"
            width="105"
            title="佣金率(%)"
            align="center"
          >
          </vxe-table-column> -->
          <vxe-table-column field="clientName" width="150" title="客户名称" align="center" show-overflow>
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row }">
              <div v-if="isinitByOrder">
                {{ row.clientName }}
              </div>
              <div class="link-text" :title="row.clientName" @click="openChooseAccount(row, 'clientName')" v-else>
                {{ row.clientName ? row.clientName : "选择收款客户" }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="moneyType" width="120" title="资金类型" align="center">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row }">
              <vxe-select
                  v-model="row.moneyType"
                  :options="moneyTypeOption"
                  placeholder="请选择"
                  transfer
              ></vxe-select>
            </template>
          </vxe-table-column>
          <!--          <vxe-table-column title="客户手机号" field="clientRegisiterNum" width="200">-->
          <!--            <template v-slot="{ row }">-->
          <!--              <vxe-input v-model="row.clientRegisiterNum" placeholder="选填"></vxe-input>-->
          <!--            </template>-->
          <!--          </vxe-table-column>-->
          <vxe-table-column width="120" field="addTime" title="日期">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }}<i style="color: #f00" v-show="payType === 1"> * </i></span>
            </template>
            <template v-slot="{ row }">
              <vxe-input
                  v-model="row.addTime"
                  placeholder="请选择"
                  type="date"
                  :editable="false"
                  :disabled="payType === 0 || isAcc"
                  prefix-icon
                  transfer
              ></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="payAmount" title="金额">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="scope">
              <vxe-input
                  :disabled="isAcc"
                  v-model="scope.row.payAmount"
                  v-on:input="inputPayAmountEvent(scope.row)"
                  @input="$refs.xTable1.updateStatus(scope)"
                  placeholder="必填"
                  type="number"
              ></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="note" title="摘要">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row }">
              <vxe-input v-model="row.note" v-if="!isAcc" placeholder="必填" maxlength="200"></vxe-input>
              <span v-else>{{ row.note }}</span>
            </template>
          </vxe-table-column>

          <!-- 承运人 -开始 -->
          <vxe-table-column width="200" field="paymentsName" title="付款账户">
            <!--            <template v-slot:header="{ column }">-->
            <!--              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>-->
            <!--            </template>-->
            <template v-slot="{ row, $rowIndex }">
              <div
                  v-if="!isAcc"
                  :title="row.paymentsName"
                  class="link-text"
                  @click="openBankAccountModal(row, $rowIndex, 'paymentsName')"
              >
                {{ row.paymentsName == null || row.paymentsName == "" ? "选择付款账户" : row.paymentsName }}
              </div>
              <div v-else>{{ row.paymentsName }}</div>
            </template>
          </vxe-table-column>

          <vxe-table-column width="220" field="payAccount" title="付款账号">
            <!--            <template v-slot:header="{ column }">-->
            <!--              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>-->
            <!--            </template>-->
          </vxe-table-column>
          <vxe-table-column width="150" field="payBank" title="付款开户行">
            <!--            <template v-slot:header="{ column }">-->
            <!--              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>-->
            <!--            </template>-->
          </vxe-table-column>


          <vxe-table-column width="200" field="recName" title="收款账户">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row, $rowIndex }">
              <vxe-input v-if="!isAcc" v-model="row.recName" placeholder="请输入收款账户">
                <template #suffix>
                  <Icon v-if="!isAcc"
                        style="color: #2d8cf0; font-size: 20px; cursor: pointer"
                        type="ios-list-box-outline"
                        @click="openBankAccountModal(row, $rowIndex, 'recName')"
                  />
                </template>
              </vxe-input>
              <span v-else>{{ row.recName }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column width="220" field="recAccount" title="收款账号">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="scope">
              <vxe-input
                  v-if="!isAcc"
                  v-model="scope.row.recAccount"
                  @input="$refs.xTable1.updateStatus(scope)"
                  placeholder="必填"
              ></vxe-input>
              <span v-else>{{ scope.row.recAccount }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="recBank" title="收款开户行">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="scope">
              <vxe-input
                  v-if="!isAcc"
                  v-model="scope.row.recBank"
                  @input="$refs.xTable1.updateStatus(scope)"
                  placeholder="必填"
              ></vxe-input>
              <span v-else>{{ scope.row.recBank }}</span>
            </template>
          </vxe-table-column>
          <!-- 平台跟销售方 结束 -->
          <vxe-table-column width="150" field="fileList" title="操作" align="center">
            <template v-slot="{ row }">
              <upload-row :row="row" :initFileList="row.fileList"></upload-row>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <upload-table ref="uploadTable" style="margin-top: 20px;margin-bottom: 50px;" :row="uploadData[0]"
                    :initFileList="fileList"></upload-table>
      <!--END 线下付款-->
      <div class="footer-btn">
        <Button type="primary" @click="importEvent" v-if="payType == 1 && (isImport || isCurImport)"
                style="margin-right: 10px;">上传导入文件
        </Button>
        <Button type="primary" @click="submitEvent('new')">提交</Button>
        <Button
            type="primary"
            @click="showTempModal"
            class="left10"
            v-if="
            payType == 1 &&
              (isHavePermission('payments:createPaymentsSeller') ||
                isHavePermission('payments:createPaymentsSellerLv2')) &&
              !isCurImport &&
              !isImport && !isAcc
          "
        >批量导入
        </Button>
        <Button type="primary" class="left10" @click="submitEvent('save')" v-if="!isAcc">保存</Button>
      </div>
    </div>
    <!-- 弹窗 -->
    <!-- 选择关联订单 -->
    <vxe-modal
        v-model="isShowChooseOrder"
        width="1300"
        height="700"
        resize
        remember
        title="选择订单"
        destroy-on-close
    >
      <choose-order @choose="chooseOrderOnlineEvent" ref="refPaymentAboutOrder" :isSub="true"></choose-order>
    </vxe-modal>
    <!-- 选择所属方 -->
    <vxe-modal
        v-model="isShowPayAccount"
        width="800"
        height="600"
        resize
        remember
        :title="payType == 1 ? '选择所属方' : '选择付款所属方'"
    >
      <pay-account @choose="choosePayAccountEvent" ref="choosePayAccount"></pay-account>
    </vxe-modal>

    <!-- 选择企业 -->
    <vxe-modal
        v-model="isShowChooseAccount"
        width="800"
        height="600"
        resize
        remember
        title="选择客户"
    >
      <choose-account @choose="chooseAccountEvent" ref="chooseAccount"></choose-account>
    </vxe-modal>

    <!-- 选择银行账户 -->
    <vxe-modal
        v-model="isShowBankAccountModal"
        width="900"
        height="600"
        resize
        remember
        :title="bankAccountModalTitle"
        :showHeader="false"
    >
      <bank-account
          @close="closeBankAccount"
          @choose="chooseBankAccount"
          :isShow="isShowBankAccountModal"
          ref="bankAccountModal"
      ></bank-account>
    </vxe-modal>
    <vxe-modal
        v-model="templateVisible"
        title="费用支出流程流程导入"
        width="1000"
        height="650"
        @close="closeTemplate"
        remember
    >
      <import @goImport="goImport" @close="closeTemplate" ref="modalTemplate"></import>
    </vxe-modal>
    <vxe-modal
        v-model="isShowCollectionOrder"
        width="1300"
        height="700"
        resize
        remember
        title="选择订单"
    >
      <about-collection-order :chainId="chainId" @choose="chooseOrderEvent" ref="refCollectionAboutOrder"
                              :isSub="true"></about-collection-order>
    </vxe-modal>
    <vxe-modal v-model="isShowFinance" width="800" height="600" resize remember title="选择子账户">
      <finance-account @choose="chooseFinanceAccount" ref="financeAccount"></finance-account>
    </vxe-modal>
    <vxe-modal
        v-model="isShowBindAccount"
        width="800"
        height="600"
        resize
        remember
        title="选择提现开户银行"
    >
      <bind-account @choose="chooseBindAccount" ref="BindAccount"></bind-account>
    </vxe-modal>
    <vxe-modal v-model="batchModal" width="500" height="200" resize remember title="批量填写">
      <batch-add ref="batchAddModal" @batchAdd="batchAdd" @close="batchModal = false"></batch-add>
    </vxe-modal>
  </div>
</template>

<script>
import $C from "@/consts/index";
import XLSX from "xlsx";
import $api from "@/apiProvider";
import Auth from "@/utils/auth.js";
import UploadList from "@/components/common/UploadList";
import Account from "@/components/modal/Account";
import PayAccount from "@/components/modal/PayAccount";
import BankAccount from "@/components/proceduremodal/PayBankAccount";
import PaymentAboutOrder from "@/components/proceduremodal/PayAboutOrder";
import {apiRequest} from "@/utils/api";
import {
  getExcelTime,
  paymentFooter,
  showLoading,
  hideLoading,
  showFailMsgList,
  isEmpty,
  isNotEmpty,
} from "@/utils/util";
import {timeFormatDate, timeToVal} from "@/filters/time";
import TableHeader from "@/components/common/TableHeader";
import SalesMan from "@/components/common/SalesMan";
import getAuthOrization from "@/mixin/getAuthOrization";
import DetailHeader from "@/views/procedure/DetailHeaderTwo";
import PlatformCorp from "@/components/common/PlatformCorp";
import AboutCollectionOrder from "@/components/proceduremodal/CollectionOrder";
import Import from "@/components/common/Import"; // 导入
import FinanceAccount from "@/components/modal/FinanceAccount";
import BindAccount from "@/components/modal/BindAccount";
import BatchAdd from "@/components/proceduremodal/BatchAdd";
import UploadTable from "@/components/modal/UploadTable";
import UploadRow from "@/components/modal/UploadRow";

import moment from "moment";

moment.locale("zh-CN");

const assign = (o) => Object.assign({}, o);

export default {
  mixins: [getAuthOrization],
  name: "CreatePayment",
  components: {
    TableHeader,
    ChooseOrder: PaymentAboutOrder,
    UploadRow,
    BankAccount,
    ChooseAccount: Account,
    DetailHeader,
    Import,
    SalesMan,
    AboutCollectionOrder,
    FinanceAccount,
    PayAccount,
    BindAccount,
    BatchAdd,
    UploadTable
  },
  props: {
    cate: {
      type: String,
      default: "",
    },
    // isShow: {
    //   type: Boolean,
    //   default: false,
    // },
    chainId: {
      type: Number,
    },
  },
  data() {
    let userInfoValue = {};
    if (Auth.isLogin()) {
      userInfoValue = Auth.getAuth();
    }
    return {
      isOrder: false,
      isShow: false,
      batchModal: false,
      isImport: false,
      userInfoValue,
      payType: 1,
      formData: {},
      canInsert: true,
      isShowChooseOrder: false,
      //选择银行账户
      isShowBankAccountModal: false,
      bankAccountModalTitle: "选择银行账户",
      isShowChooseAccount: false, // 选择客户
      isShowPayAccount: false,
      amountListName: "", //关联订单的字段名
      dataTmp: {
        index: "",
        ordersNum: null,
        addTime: "",
        fileUuidList: [],
        fileList: [],
        note: null,
        operUser: null,
        ordersBuyerAmountList: [],
        ordersSellerAmountList: [],
        ordersSellerLv2sAmountList: [],
        payAccount: null,
        payAmount: "",
        payBank: null,
        payBankCode: null,
        paymentsName: null,
        payCompName: null,
        recAccount: null,
        recBank: null,
        recName: null,
        recCompName: null,
        rateManage: null,
        unusedAmount: 0,
        usedAmount: 0,
        compName: "",
        isOrderCompName: false,
        salesMan: "",
        isOrdersalesMan: false,
        clientName: "",
        isOrderClientName: false,
        ordersList: [],
        isDraw: 0,
        drawBank: null,
        drawAccount: null,
        isDrawAccountNew: null,
        switchVal: false,
        inputDrawBank: "",
        drawOpenOrgNum: null,
        payAccountObj: null,
        recAccountObj: null,
        compNameType: 0,
        recNameType: 1,
      },
      tableData: [],
      editRules: {
        salesMan: [{validator: this.requireValid}],
        payAmount: [{validator: this.requireValid}],
        addTime: [{validator: this.requireValid}],
        note: [{validator: this.requireValid}],
        paymentsName: [{validator: this.requireValid}],
        recName: [{validator: this.requireValid}],
        clientName: [{validator: this.requireValid}],
        drawBank: [{validator: this.requireValid}],
        payBankOwn: [{validator: this.requireValid}],
        payAccount: [{validator: this.requireValid}],
        recBankOwn: [{validator: this.requireValid}],
        recAccount: [{validator: this.requireValid}],
        drawAccount: [{validator: this.requireValid}],
        drawOpenOrgNum: [{validator: this.requireValid}],
        moneyType: [{validator: this.requireValid}]
      },
      editRules2: {
        salesMan: [{validator: this.requireValid}],
        payAmount: [{validator: this.requireValid}],
        addTime: [{validator: this.requireValid}],
        note: [{validator: this.requireValid}],
        // paymentsName: [{validator: this.requireValid}],
        recName: [{validator: this.requireValid}],
        clientName: [{validator: this.requireValid}],
        drawBank: [{validator: this.requireValid}],
        recBank: [{validator: this.requireValid}],
        recAccount: [{validator: this.requireValid}],
        drawAccount: [{validator: this.requireValid}],
        drawOpenOrgNum: [{validator: this.requireValid}],
        moneyType: [{validator: this.requireValid}]
      },
      platformCompMap: {},
      platformCompanyId: null,
      paymentType: null,
      orderInfo: null,
      orderType: null,
      isBuyerLine: false, // 是否托运人线上支付
      fromOrigin: null,
      initRecord: {},
      isSubmit: false,
      isChangeType: false,
      flowTempletId: 7,
      isLoaded: false,
      isCurImport: false,
      templateVisible: false,
      isinitByOrder: false,
      uploadData: [
        {
          fileList: null,
        },
      ],
      isShowCollectionOrder: false,
      salesManData: null,
      isShowFinance: false,
      // isinitByOrder: "",
      isDrawType: [
        {
          label: "是",
          value: 1,
        },
        {
          label: "否",
          value: 0,
        },
      ], // 是否提现
      isShowBindAccount: false,
      isInitBySave: false,
      fileList: [],
      initBySaveId: null,
      infoTxt: "(单笔提现金额超100万，服务时间为法定工作日20:30-次日17:15)",
      bankList: [],
      bankInfo: null,
      payBankKey: [],
      isShowAccountNewTip: false,
      isSaleMan: false,
      isAcc: false,
      accData: {},
      moneyTypeOption: []
    };
  },
  watch: {
    tableData: {
      deep: true,
      immediate: true,
      handler: function (val) {
        this.isShowAccountNewTip = val.some((item) => item.isDrawAccountNew === 1);
      },
    },
    isShow: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val == false && oldVal == true) {
          if (isNotEmpty(this.$refs[this.tableName])) {
            this.$refs[this.tableName].clearValidate();
            this.$refs[this.tableName].scrollTo(0, 0);
            this.updateFooterEvent();
          }
          this.payType = 1;
          this.tableData = [];
          this.uploadData = [];
          let fileObj = {
            fileList: null,
          };
          this.uploadData.push(fileObj);
          this.$nextTick(() => {
            this.$refs.uploadTable.init();
          })
          // debugger
          this.canInsert = true;
          this.isSubmit = false;
          this.isChangeType = false;
          this.isLoaded = false;
          this.isinitByOrder = false;
          this.salesManData = null;
          this.isImport = false;
        }
        if (val == true && !this.isInitBySave) {
          // this.insertEvent();
          this.tableData = [];
          this.uploadData = [];
          let fileObj = {
            fileList: null,
          };
          this.uploadData.push(fileObj);
          this.$nextTick(() => {
            this.$refs.uploadTable.init();
          })
          this.getFlowData();
          this.resetFormData();
        }
      },
    },
    payType: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val !== oldVal && oldVal !== undefined) {
          this.changeType();
        }
      },
    },
  },
  computed: {
    isShowDrawOpenOrgNum() {
      return this.tableData.some((item) => item.switchVal);
    },
    tableName() {
      return this.payType === 0 ? "xTable" : "xTable1";
    },
  },
  created() {
    this.isShow = true;
    this.getBankInfo();
  },
  mounted() {
    this.getDicMoneyType();
    if (this.userInfoValue.identityType === 0) {
      this.isSaleMan = true;
      this.salesMan = this.userInfoValue.name;
      this.salesManId = this.userInfoValue.id;
      let tableData = this.$refs[this.tableName].getTableData().tableData;
      tableData.map(i => {
        i.salesMan = this.userInfoValue.name;
        i.salesManId = this.userInfoValue.id;
      })
    }
    if (this.$route.params.flowId) {
      this.initBySave(this.$route.params.flowId);
    }
    if (this.$route.params.isOrder) {
      this.isOrder = true;
      this.payType = 0;
      let detailData = JSON.parse(localStorage.getItem('detailData'))
      this.initByOrderInfo(detailData, this.$route.params.orderType);
    }
    if (this.$route.params.isAcc) {
      this.isAcc = true;
      this.payType = 1;
      this.formData.payType = 1;
      let accData = JSON.parse(localStorage.getItem('accDetail'));
      this.accData = accData;
      this.initByAcc(accData);
    }
  },
  methods: {
    getDicMoneyType() {
      this.moneyTypeOption = [];
      $api.other.getMoneyTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              var obj = {
                label: item.dictText,
                value: item.dictCode,
              };
              this.moneyTypeOption.push(obj);
            });
          });
    },
    initByAcc(accData) {
      // this.insertEvent();
      this.currentRow = this.$refs[this.tableName].getTableData().tableData[0];
      this.currentRow.addTime = timeFormatDate(accData.procTimestamp);
      this.currentRow.payAmount = accData.tradeAmount;
      this.currentRow.note = accData.note;

      this.currentRow.paymentsName = accData.payName;
      this.currentRow.payAccount = accData.payAccount;
      this.currentRow.payBank = accData.payBank;

      this.currentRow.recName = accData.recName;
      this.currentRow.recAccount = accData.recAccount;
      this.currentRow.recBank = accData.recBank;

      this.compName = accData.memName;
      this.currentRow.compName = accData.memName;
      this.currentRow.clientName = accData.otherName;
      this.currentRow.clientId = accData.otherSubjectId;
      this.currentRow.payBankCode = accData.fcsSerialNum;
      this.$refs[this.tableName].reloadData([this.currentRow]);
    },
    batchAdd(data) {
      this.checkboxRecords.map(i => {
        i.salesMan = data.name;
        i.salesManId = data.id;
      })
      this.batchModal = false;
      this.$refs[this.tableName].clearValidate();
    },
    openBatchAdd() {
      let checkboxRecords = this.$refs[this.tableName].getCheckboxRecords();
      this.checkboxRecords = checkboxRecords;
      if (isEmpty(checkboxRecords)) {
        this.$XModal.alert({
          message: '至少勾选一条记录',
          status: "error",
        });
        return;
      }
      this.batchModal = true;
      this.$nextTick(() => {
        this.$refs.batchAddModal.init();
      })
    },
    async getBankInfo() {
      let res = await $api.dict.post("queryDictByCode", {
        id: 110,
      });
      if (res.status === 1) {
        this.bankInfo = JSON.parse(res.data.note);
        for (let k in this.bankInfo) {
          this.payBankKey.push(k);
        }
      }
    },
    checkNum(field, num, i, val) {
      let message =
          field === "drawAccount" ? "请输入正确的提现银行账号！" : "请输入正确的银行联号！";
      if (
          (field === "drawAccount" && val.value.length >= num) ||
          (field === "drawOpenOrgNum" && val.value.length !== num)
      ) {
        this.$XModal.message({status: "error", message});
        this.tableData[i][field] = null;
      }
    },
    bankFocusEvent(row) {
      // console.log(row);
      if (!row.switchVal) {
        this.$refs.bankDown.showPanel();
      }
    },
    bankKeyupEvent(row, i) {
      this.tableData[i].drawOpenOrgNum = null;
      if (!row.switchVal) {
        this.getBankListByName(row);
      }
    },
    checkDrawOpenOrgNum(row, i) {
      if (!row.drawOpenOrgNum && !row.switchVal) {
        this.tableData[i].inputDrawBank = null;
      }
      if (row.switchVal) {
        this.tableData[i].drawBank = this.tableData[i].inputDrawBank;
      }
    },
    async getBankListByName(row) {
      let name = row.inputDrawBank;
      // if (isEmpty(name)) {
      //   this.bankList = [];
      //   return;
      // }
      let res = await $api.finance.get(`cebBankOrg/searchOrgByName/${name}`);
      if (res.status === 1 && res.message === name) {
        this.bankList = res.data;
      }
    },
    bankSelectEvent(obj, i) {
      this.tableData[i].inputDrawBank = obj.orgName;
      this.tableData[i].drawOpenOrgNum = obj.orgNum;
      this.tableData[i].drawBank = obj.orgName;
      // this.chooseBank = true;
      // this.accountData.openBankName = obj.orgName;
      // this.accountData.openOrgNum = obj.orgNum;
      this.$refs.bankDown.hidePanel();
      // this.$refs.accountFrom.updateStatus(scope);
    },
    changeSwitch(i, val) {
      // console.log(i, val);
      this.tableData[i].switchVal = val;
      this.tableData[i].drawOpenOrgNum = null;
    },
    async editBankCount(i, e) {
      let tableData = this.$refs[this.tableName].getTableData().fullData;
      tableData[i].isDrawAccountNew = 1;
      tableData[i].drawAccount = e.value.replace(/\s+/g, "");
      this.isShowAccountNewTip = true;
    },
    async editDrawOpenOrgNum(i, e) {
      let tableData = this.$refs[this.tableName].getTableData().fullData;
      tableData[i].drawOpenOrgNum = e.value.replace(/\s+/g, "");
    },
    getPayObj(val) {
      this.formData = val;
      this.payType = val.type;
    },
    getFlowData() {
      let obj = {flowTempletId: this.flowTempletId};
      $api.flowInstance.createFlowModel
          .GET({
            params: obj,
          })
          .then((res) => {
            if (res.status === 1) {
              this.formData = res.data;
              document.title = res.data.instanceName;
              if (this.isOrder) {
                this.$set(this.formData, 'compName', this.orderInfo.compName);
              }
              if (this.isAcc) {
                this.$set(this.formData, 'compName', this.accData.memName);
                this.$set(this.formData, 'payType', 1);
              }
              this.isLoaded = true;
            } else {
              this.$XModal.confirm(res.message).then(() => {
                window.close();
              });
            }
          });
    },
    async initBySave(id) {
      this.isInitBySave = true;
      this.initBySaveId = id;
      let payType;
      $api.flowInstance.queryDraftFlowDetail
          .GET({
            params: {
              id,
            },
          })
          .then((res) => {
            if (res.status === 1) {
              document.title = res.data.instanceName;
              payType = res.data.payType === 0 ? 1 : 0;
              this.formData = Object.assign(res.data, {
                payType: res.data.payType === 0 ? 1 : 0,
              });
              this.isLoaded = true;
              this.fileList = res.data.attachFile;
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error",
              });
            }
          });
      let params = {
        page: 1,
        rows: 10000,
        orderBy: 2,
        isDesc: 0,
        flowId: id,
      };
      params.paymentType = 2;
      let resData = await $api.paymentsTwo.request("queryPaymentsListByFlowId", params);
      if (resData.status == 1) {
        this.tableData = resData.data.rows.map((item) => {
          let isDraw = payType === 1 ? 0 : item.isDraw;
          return Object.assign(item, {
            addTime: timeFormatDate(item.addTime),
            isDraw,
          });
        });
        if (this.tableData[0]) {
          this.formData.compName = this.tableData[0].compName;
          this.queryMemList(this.tableData[0].compName);
        }
      }
    },
    async queryMemList(name) {
      let payRes = await apiRequest("api/finance/", "cebBusiMem/queryMemList", {
        orderBy: 2,
        page: 1,
        rows: 10,
        subjectType: 0,
        memName: name,
      });
      if (payRes.status === 1 && payRes.data.rows && payRes.data.rows.length === 1) {
        this.account = payRes.data.rows[0];
      }
    },
    changeIsDraw(row, i) {
      let tableData = this.$refs[this.tableName].getTableData().fullData;
      tableData[i].drawBank = null;
      tableData[i].drawAccount = null;
      tableData[i].isDrawAccountNew = null;
      tableData[i].inputDrawBank = null;
      tableData[i].drawOpenOrgNum = null;
    },
    changeType() {
      this.salesManData = null;
      this.isChangeType = true;
      this.account = {};
      this.$refs[this.tableName].remove();
      if (this.orderType === 1) {
        if (this.payType === 0) {
          this.isBuyerLine = true;
        } else {
          this.isBuyerLine = false;
        }
      }

      if (this.fromOrigin === "order") {
        this.initByOrderInfo(this.orderInfo, this.orderType);
      } else {
        this.insertEvent();
      }

      if (this.isAcc) {
        this.initByAcc(this.accData);
      }
    },
    resetFormData() {
      this.payType = 0;
    },
    initByOrderInfo(orderInfo, orderType = 0) {
      this.fromOrigin = "order";
      this.isinitByOrder = true;
      this.orderInfo = orderInfo;
      this.orderType = orderType;
      this.insertEvent();
      this.currentRow = this.$refs[this.tableName].getTableData().tableData[0];
      this.currentRow.compName = this.orderInfo.compName;
      this.$set(this.formData, 'compName', this.orderInfo.compName);

      // this.currentRow.payAmount = null;
      // this.currentRow.note = null;
      // if (this.cate === "Collection" || this.isBuyerLine) {
      //   orderInfo.ordersNum = orderInfo.buyerOrdersNum;
      // } else {
      //   orderInfo.ordersNum = orderInfo.sellerOrdersNum;
      // }
      // orderInfo.ordersId = orderInfo.id;
      // ?????
      // orderInfo.id = null;
      // orderInfo.paymentType = orderType;
      // console.log(orderInfo);
      let selOrderArr = [];
      let selOrderObj = {
        aboutAmount: null,
        buyerName: orderInfo.buyerName,
        id: orderInfo.ordersId,
        ordersId: orderInfo.ordersId,
        ordersNum: orderInfo.ordersNum,
        salesManId: orderInfo.saleManId,
        salesMan: orderInfo.saleMan,
        sellerName: orderInfo.sellerName,
        paymentType: orderInfo.paymentType,
        buyerId: orderInfo.buyerId,
        sellerId: orderInfo.sellerId,
      };
      selOrderArr.push(selOrderObj);

      let firstLine = this.chooseOrderEvent(selOrderArr, 0);
      firstLine.then(() => {
        this.initRecord = this.currentRow;
        this.$refs[this.tableName].reloadData([this.initRecord]);
      });
      // console.log(orderInfo);
      this.currentRow.compName = orderInfo.compName;
      this.currentRow.platformCompanyId = orderInfo.platformCompanyId;
      this.platformCompanyId = orderInfo.platformCompanyId;

      if (isNotEmpty(orderInfo.saleMan)) {
        this.currentRow.salesMan = orderInfo.saleMan;
        this.currentRow.salesManId = orderInfo.saleManId;
      }
      if (isNotEmpty(orderInfo.rateManage)) {
        this.currentRow.rateManage = orderInfo.rateManage;
        this.currentRow.commission = orderInfo.rateManage;
      }
    },
    initByCate(cate) {
      this.fromOrigin = "cate";
      // this.insertEvent();
      // console.log(this.cate, cate);
    },
    async requireValid(e) {
      if (e.columnIndex === 4 && isEmpty(e.row.clientName)) {
        return Promise.reject(new Error("请先选择客户名称"));
      }
      if (this.payType === 1 && e.columnIndex === 6 && isEmpty(e.row.payAmount)) {
        return Promise.reject(new Error("请先填写付款金额"));
      }

      if (isNotEmpty(e.row.compName) && e.row.aboutAmount > 0 && e.columnIndex == 2 && this.isImport && isEmpty(e.row.ordersNum)) {
        return Promise.reject(new Error("导入必须填写订单号"));
      }
      if (isEmpty(e.cellValue)) {
        if (
            // (e.columnIndex === 8 && this.payType === 0) ||
            (e.columnIndex === 2 && this.payType === 1) ||
            (e.columnIndex === 4 && this.payType === 1) ||
            (e.column.title == "提现银行账号" && e.row.isDraw !== 1) ||
            (e.column.title == "提现开户银行" && e.row.isDraw !== 1) ||
            (e.column.title == "联行号" && e.row.isDraw !== 1)
        ) {
          console.log("线上支付不需要填日期");
        } else {
          return Promise.reject(new Error(e.column.title + "必填"));
        }
      }
    },
    showTempModal() {
      if (isEmpty(this.formData.compName)) {
        this.$XModal.message({status: "error", message: "请先选择所属公司"});
        return
      }
      this.templateVisible = true;
      this.$nextTick(() => {
        this.$refs.modalTemplate.setExport("费用支出流程线下支付导入模板-0628.xls");
      });
    },
    closeTemplate() {
      this.templateVisible = false;
    },
    goImport() {
      this.importEvent();
      // this.isCurImport = true;
      this.templateVisible = false;
    },
    async importEvent() {
      await this.initPlatCompMap();
      this.$refs[this.tableName]
          .readFile({
            types: ["xls", "xlsx"],
          })
          .then((evnt) => {
            showLoading();
            const tableData = [];
            // const importIds = [];
            this.isImport = true;
            const files = evnt.target.files;
            const fileReader = new FileReader();
            fileReader.onload = async (ev) => {
              const data = ev.target.result;
              const workbook = XLSX.read(data, {type: "binary"});
              const csvData = XLSX.utils.sheet_to_csv(Object.values(workbook.Sheets)[0]);
              // 解析数据
              if (csvData.split("\n").length > 302) {
                hideLoading();
                this.$XModal.alert({
                  message: "本次导入数据超过300条",
                  status: "error",
                });
                return
              }
              csvData.split("\n").forEach((vRow, index) => {
                if (vRow && index > 0) {
                  const vCols = vRow.split(",");
                  // importIds.push(vCols[1]);

                  let moneyType = null;
                  if (vCols[4]) {
                    this.moneyTypeOption.map(i => {
                      if (i.label === vCols[4]) {
                        moneyType = i.value;
                      }
                    })
                  }
                  let item = {
                    index: vCols[0] ? vCols[0].trim() : null, //需要
                    ordersNum: vCols[1] ? vCols[1].trim() : null, //承运人订单号
                    compName: this.compName ? this.compName : this.formData.compName,
                    salesMan: vCols[2] ? vCols[2].trim() : null,
                    clientName: vCols[3] ? vCols[3].trim() : null,
                    moneyType: moneyType,
                    clientRegisiterNum: vCols[5],
                    addTime: getExcelTime(vCols[6]), //收款日期-
                    payAmount: vCols[7] ? vCols[7].trim() : null, //付款金额
                    note: vCols[8] ? vCols[8].trim() : null, //摘要
                    isOrderCompName: false,
                    isOrdersalesMan: false,
                    isOrderClientName: false,
                    paymentsName: vCols[9] ? vCols[9].trim() : null, //付款企业（人）名称
                    payAccount: vCols[10] ? vCols[10].trim() : null, //银行卡号
                    payBank: vCols[11] ? vCols[11].trim() : null, //开户行
                    recName: vCols[12] ? vCols[12].trim() : null, //收款企业（人）名称
                    recAccount: vCols[13] ? vCols[13].trim() : null, //银行卡号
                    recBank: vCols[14] ? vCols[14].trim() : null, //开户行
                  };

                  item.ordersList = [
                    {
                      ordersNum: item.ordersNum,
                      aboutAmount: item.payAmount,
                    },
                  ];
                  item.platformCompanyId = this.platformCompMap[item.compName];
                  tableData.push(item);
                }
              });
              // let res = {};
              // if (importIds.length == 0) {
              //   res.status == 1;
              //   res.data = [];
              // } else {
              //   res = await $api.ordersSeller.post(
              //     "queryOrdersSellerSalesInfoList",
              //     importIds
              //   );
              // }
              // if (res.status == 1) {
              //   let orders = res.data;
              //   tableData.map(i => {
              //     console.log(i, orders);
              //     if (i.ordersNum) {
              //       let orderInfo = orders.find(j => j.ordersNum === i.ordersNum);
              //       if (isNotEmpty(orderInfo)) {
              //         if (isEmpty(i.platformCompanyId)) {
              //           i.platformCompanyId = orderInfo.ownPlatformCompanyId
              //             ? orderInfo.ownPlatformCompanyId
              //             : "";
              //         }
              //         if (isEmpty(i.clientName)) {
              //           i.clientName = orderInfo.clientName
              //             ? orderInfo.clientName
              //             : "";
              //         }
              //         if (isEmpty(i.compName)) {
              //           i.compName = orderInfo.ownName ? orderInfo.ownName : "";
              //         }
              //         if (isEmpty(i.salesMan)) {
              //           i.salesMan = orderInfo.salesMan ? orderInfo.salesMan : "";
              //           i.salesManId = orderInfo.salesManId
              //             ? orderInfo.salesManId
              //             : "";
              //           i.isOrderSalesMan = true;
              //         }
              //         if (
              //           i.salesMan == orderInfo.salesMan &&
              //           i.compName == orderInfo.ownName
              //         ) {
              //           i.commission = i.rateManage = orderInfo.rateManage
              //             ? orderInfo.rateManage
              //             : "";
              //         }
              //         i.ownName = orderInfo.ownName ? orderInfo.ownName : "";
              //         i.paymentType = orderInfo.orderType
              //           ? orderInfo.orderType
              //           : "";

              //         i.ordersAmountList = [
              //           {
              //             ordersNum: i.ordersNum,
              //             aboutAmount: i.payAmount,
              //             paymentType: orderInfo.orderType
              //           }
              //         ];
              //       }
              //     }
              //   });
              // }

              this.tableData = tableData;
              this.updateFooterEvent();
              hideLoading();
              // setTimeout(() => {
              //   hideLoading();
              // }, 1000);
            };
            fileReader.readAsBinaryString(files[0]);
          });
    },
    insertEvent() {
      if (isEmpty(this.$refs[this.tableName])) return;
      let tableData = this.$refs[this.tableName].getTableData().tableData;
      this.$refs[this.tableName].clearValidate();
      let record = assign(this.dataTmp);
      if (this.isinitByOrder) {
        //不能新增的情况下 都是复制第一条的
        if (tableData.length > 0) {
          let amountList;
          if (tableData[0][this.amountListName] && tableData[0][this.amountListName].length > 0) {
            amountList = [assign(tableData[0][this.amountListName][0])];
          }
          if (this.payType === 1) {
            record = Object.assign(record, {
              ordersNum: this.initRecord.ordersNum, //承运人订单号
              ordersId: this.initRecord.ordersId,
              salesMan: this.initRecord.salesMan,
              salesManId: this.initRecord.salesManId,
              commission: this.initRecord.commission,
              rateManage: this.initRecord.commission,
              compName: this.initRecord.compName,
              platformCompanyId: this.initRecord.platformCompanyId,
              clientName: this.initRecord.clientName,
              clientId: this.initRecord.clientId,
              paymentsName: null,
              payCompName: null,
              payBank: null,
              payAccount: null,
              recBank: null,
              recName: null,
              recAccount: null,
              recCompName: null,
              ordersList: this.initRecord.ordersList,
              [this.amountListName]: amountList,
              isDraw: 0,
              drawBank: null,
              drawAccount: null,
              drawOpenOrgNum: null,
              isDrawAccountNew: null,
              switchVal: false,
              inputDrawBank: "",
              payAccountObj: null,
              recAccountObj: null,
              clientRegisiterNum: null,
            });
          } else {
            record = Object.assign(record, {
              clientId: this.initRecord.clientId,
              ordersNum: this.initRecord.ordersNum, //承运人订单号
              ordersId: this.initRecord.ordersId,
              salesMan: this.initRecord.salesMan,
              salesManId: this.initRecord.salesManId,
              commission: this.initRecord.commission,
              rateManage: this.initRecord.commission,
              compName: this.initRecord.compName,
              platformCompanyId: this.initRecord.platformCompanyId,
              clientName: this.initRecord.clientName,
              paymentsName: this.initRecord.paymentsName,
              payCompName: this.initRecord.payCompName,
              payBank: this.initRecord.payBank,
              payAccount: this.initRecord.payAccount,
              recBank: this.initRecord.recBank,
              recName: this.initRecord.recName,
              recAccount: this.initRecord.recAccount,
              recCompName: this.initRecord.recCompName,
              ordersList: this.initRecord.ordersList,
              [this.amountListName]: amountList,
              isDraw: 0,
              drawBank: null,
              drawAccount: null,
              drawOpenOrgNum: null,
              isDrawAccountNew: null,
              switchVal: false,
              inputDrawBank: "",
              payAccountObj: null,
              recAccountObj: null,
            });
          }
        }
      } else {
        let salesMan = this.userInfoValue.identityType === 0 ? this.userInfoValue.name : null,
            salesManId = this.userInfoValue.identityType === 0 ? this.userInfoValue.id : null;
        record = {
          ordersNum: null, //承运人订单号
          ordersId: null,
          salesMan,
          salesManId,
          commission: null,
          compName: this.compName ? this.compName : this.tableData[0] ? this.tableData[0].compName : this.formData.name,
          platformCompanyId: this.platformCompanyId ? this.platformCompanyId : this.tableData[0] ? this.tableData[0].platformCompanyId : null,
          clientName: null,
          payBank: this.account ? this.account.busiSubjectName : null,
          payBankOwn: this.account ? this.account.busiSubjectName : null,
          paymentsName: this.account ? this.account.memName : null,
          payCompName: this.account ? this.account.busiSubjectName : null,
          payAccount: this.account ? this.account.subAcc : null,
          recCompName: null,
          recBank: null,
          recName: null,
          recAccount: null,
          rateManage: null,
          isDraw: 0,
          drawBank: null,
          drawAccount: null,
          drawOpenOrgNum: null,
          isDrawAccountNew: null,
          switchVal: false,
          inputDrawBank: "",
          payAccountObj: null,
          recAccountObj: null,
          paymentsType: 0
        };
      }
      record.index = tableData.length + 1;
      record.fileList = [];
      record.fileUuidList = [];
      this.$refs[this.tableName].insertAt(record, -1);
      this.$refs[this.tableName].updateStatus();
      this.tableData = this.$refs[this.tableName].getTableData().tableData;
      this.updateFooterEvent();
    },
    async removeEvent() {
      let checkboxRecords = this.$refs[this.tableName].getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({message: "没有选择"});
        return;
      }

      let confirmRes = await this.$XModal.confirm("删除后不可恢复", "是否删除？");
      if (confirmRes == "confirm") {
        this.$refs[this.tableName].removeCheckboxRow();
        this.$refs[this.tableName].updateStatus();
      }
    },
    copyEvent() {
      let checkboxRecords = this.$refs[this.tableName].getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({message: "没有选择"});
        return;
      }
      let newRecords = [];
      checkboxRecords.forEach((item) => {
        let newItem = assign(item);
        let newAmountList = [];
        if (newItem[this.amountListName]) {
          newItem[this.amountListName].forEach((i) => {
            newAmountList.push(assign(i));
          });
          newItem[this.amountListName] = newAmountList;
        }

        // console.log(newItem);
        newRecords.push(assign(newItem));
      });
      this.$refs[this.tableName].insertAt(newRecords, -1);
      this.$refs[this.tableName].updateStatus();
    },
    cellClickEvent(e) {
      this.$refs[this.tableName].clearValidate();
    },
    async selectCompName(row, id, name) {
      let tableData = this.$refs[this.tableName].getTableData().tableData;
      let hasComp = false;
      tableData.map(i => {
        // 选择平台清空收付款信息
        if (isNotEmpty(i.compName) && i.compName !== name) {
          hasComp = true;
        }
        if (this.salesManData && this.salesManData.rateList) {
          let arr = [];
          arr = this.salesManData.rateList.filter((item) => item.compName === name);
          i.commission = arr.length === 1 ? arr[0].rateManage : null;
        }
      })
      if (hasComp) {
        let confirmRes = await this.$XModal.confirm("更换所属平台公司将清空关联订单", "是否更换");
        if (confirmRes === "confirm") {
          tableData.map(i => {
            i[this.amountListName] = [];
            i.ordersList = [];
            i.ordersNum = null;
            i.commission = null;
          })
        } else {
          return;
        }
      }

      if (this.payType === 0) {
        // 自动带数据
        let payRes = await apiRequest("api/finance/", "cebBusiMem/queryMemList", {
          orderBy: 2,
          page: 1,
          rows: 10,
          subjectType: 0,
          memName: name,
        });
        if (payRes.status === 1 && payRes.data.rows && payRes.data.rows.length === 1) {
          tableData.map(i => {
            this.account = payRes.data.rows[0];
            i.payBank = payRes.data.rows[0].busiSubjectName;
            i.payBankOwn = payRes.data.rows[0].busiSubjectName;
            i.paymentsName = payRes.data.rows[0].memName;
            i.payCompName = payRes.data.rows[0].busiSubjectName;
            i.payAccount = payRes.data.rows[0].subAcc;
            i.paymentsType = 0;
          });
        } else {
          tableData.map(i => {
            i.payBank = null;
            i.payBankOwn = null;
            i.paymentsName = null;
            i.payCompName = null;
            i.payAccount = null;
          });
        }
      }

      this.platformCompanyId = id;
      this.compName = name;
      tableData.map(i => {
        i.platformCompanyId = id;
        i.compName = name;
        i.payAccountObj = row;
        i.compNameType = 0;
      })
      this.$refs[this.tableName].clearValidate();

      if (this.isinitByOrder) {
        tableData.map(i => {
          this.initClient(i, id)
        });
      }
    },
    async initClient(row, compId) {
      // 自动带数据
      let params = {
        orderBy: 2,
        page: 1,
        rows: 10,
      };

      params.subjectType = 1;
      params.subjectId = this.orderInfo.sellerId;
      params.busiSubjectId = compId;

      let payRes = await apiRequest("api/finance/", "cebBusiMem/queryMemList", params);
      if (
          payRes.status === 1 &&
          payRes.data.rows &&
          payRes.data.rows.length === 1
      ) {
        row.recBank = payRes.data.rows[0].busiSubjectName;
        row.recBankOwn = payRes.data.rows[0].busiSubjectName;
        row.recName = payRes.data.rows[0].memName;
        row.recCompName = payRes.data.rows[0].busiSubjectName;
        row.recAccount = payRes.data.rows[0].subAcc;
      } else {
        row.recBank = null;
        row.recBankOwn = null;
        row.recName = null;
        row.recAccount = null;
        row.recCompName = null;
      }
    },
    async setSaleMan(data, status) {
      this.salesManData = data;
      if (isNotEmpty(this.currentRow) && data && data.rateList) {
        let arr = [];
        arr = data.rateList.filter((item) => item.compName == this.currentRow.compName);
        this.currentRow.commission = arr.length == 1 ? arr[0].rateManage : null;
      }
    },
    removeOrder(row) {
      this.$set(row, 'ordersNum', null);
      this.$set(row, 'ordersList', []);
    },
    async openOrderModal(row) {
      this.type = this.payType;
      let cate = "Payment";
      this.currentRow = row;
      if (this.type === 0) {
        // 线上
        if (isNotEmpty(row.compName)) {
          this.isShowChooseOrder = true;
          this.$nextTick(() => {
            this.$refs.refPaymentAboutOrder.init(
                this.type,
                cate,
                0,
                row.payAmount,
                row.ordersList,
                row.compName,
                row.platformCompanyId,
                'pay'
            );
          })
        } else {
          this.$XModal.message({status: "error", message: "请先选择所属公司"});
          return
        }
      } else {
        // 线下
        if (this.isinitByOrder) {
          // 供应链  购方
          this.isShowChooseOrder = true;
          this.$nextTick(() => {
            this.$refs.refPaymentAboutOrder.init(
                this.type,
                cate,
                0,
                row.payAmount,
                row.ordersList,
                this.chainId,
                row.compName,
                row.platformCompanyId
            );
          })
        } else {
          if (isNotEmpty(row.payAmount) && isNotEmpty(row.compName)) {
            this.isShowCollectionOrder = true;
            this.$nextTick(() => {
              this.$refs.refCollectionAboutOrder.init(
                  this.cate,
                  0,
                  row.payAmount,
                  row.ordersList,
                  row.platformCompanyId
              );
            });
          } else {
            if (isEmpty(row.compName)) {
              this.$XModal.message({status: "error", message: "请先选择所属公司"});
              return
            }
            if (isEmpty(row.payAmount)) {
              this.$XModal.message({status: "error", message: "请先填写金额"});
              return
            }
          }
        }
      }
    },
    openPayAccount(row, field) {
      this.isShowPayAccount = true;
      this.currentRow = row;
      this.currentChooseColumn = field;
      this.$nextTick(() => {
        this.$refs.choosePayAccount.init();
      });
    },
    openChooseAccount(row, field) {
      this.isShowChooseAccount = true;
      this.currentRow = row;
      this.currentChooseColumn = field;
      this.$nextTick(() => {
        this.$refs.chooseAccount.init(this.payType);
      });
    },
    async choosePayAccountEvent(account, type) {
      this.currentRow.payAccountObj = account;
      // this.payAccountObj = account;
      this.isShowPayAccount = false;
      this.$refs[this.tableName].clearValidate(this.currentChooseColumn);
      this.currentRow.compNameType = type;
      let name = type == 0 ? account.name : account.userName;
      if (
          isNotEmpty(this.currentRow.compName) &&
          this.currentRow.compName != name &&
          isNotEmpty(this.currentRow.ordersList)
      ) {
        let confirmRes = await this.$XModal.confirm("更换所属平台公司将清空关联订单", "是否更换");
        if (confirmRes === "confirm") {
          this.currentRow[this.amountListName] = [];
          this.currentRow.ordersList = [];
          this.currentRow.ordersNum = null;
          this.currentRow.commission = null;
        } else {
          return;
        }
      }

      this.currentRow.compName = name;

      if (type == 0 && this.payType === 0) {
        // 自动带数据
        let payRes = await apiRequest("api/finance/", "cebBusiMem/queryMemList", {
          orderBy: 2,
          page: 1,
          rows: 10,
          subjectType: 0,
          memName: name,
        });
        if (payRes.status === 1 && payRes.data.rows && payRes.data.rows.length === 1) {
          this.currentRow.payBank = payRes.data.rows[0].busiSubjectName;
          this.currentRow.payBankOwn = payRes.data.rows[0].busiSubjectName;
          this.currentRow.paymentsName = payRes.data.rows[0].memName;
          this.currentRow.payCompName = payRes.data.rows[0].busiSubjectName;
          this.currentRow.payAccount = payRes.data.rows[0].subAcc;
        } else {
          this.currentRow.payBank = null;
          this.currentRow.payBankOwn = null;
          this.currentRow.paymentsName = null;
          this.currentRow.payCompName = null;
          this.currentRow.payAccount = null;
        }
        // console.log(payRes);
        this.currentRow.platformCompanyId = account.id;
        // 选择平台企业获取业务员佣金
        if (this.salesManData && this.salesManData.rateList) {
          let arr = [];
          arr = this.salesManData.rateList.filter((item) => item.compName == account.name);
          this.currentRow.commission = arr.length == 1 ? arr[0].rateManage : null;
        }
      } else {
        this.currentRow.platformCompanyId = null;
      }
      // 选择平台清空收付款信息
      if (this.payType === 0) {
        if (type !== 0) {
          this.currentRow.paymentsName = null;
          this.currentRow.payBank = null;
          this.currentRow.payBankOwn = null;
          this.currentRow.payAccount = null;
          this.currentRow.payCompName = null;
        }
        // console.log(this.currentRow);
        // debugger
        if (this.currentRow.recNameType !== 0) {
          this.currentRow.recBank = null;
          this.currentRow.recBankOwn = null;
          this.currentRow.recName = null;
          this.currentRow.recAccount = null;
          this.currentRow.recCompName = null;
        }
      }
    },
    async chooseAccountEvent(account, type) {
      // console.log("chooseAccountEvent", account);
      this.currentRow.recNameType = type;
      if (type !== 0) {
        this.currentRow[this.currentChooseColumn] = account.userName;
        this.currentRow.clientId = account.id;
      } else {
        this.currentRow[this.currentChooseColumn] = account.name;
      }
      this.currentRow.recAccountObj = account;
      // this.currentRow[this.currentChooseColumn] = account.userName;
      this.isShowChooseAccount = false;
      this.$refs[this.tableName].clearValidate(this.currentChooseColumn);
      this.currentRow.isDraw = 0;
      this.currentRow.switchVal = false;
      this.currentRow.drawBank = null;
      this.currentRow.drawAccount = null;
      this.currentRow.drawOpenOrgNum = null;
      this.currentRow.isDrawAccountNew = null;
      this.currentRow.inputDrawBank = "";
      if (this.payType === 0) {
        // 自动带数据
        let params = {
          orderBy: 2,
          page: 1,
          rows: 10,
        };
        if (type !== 0) {
          params.subjectType = 1;
          params.subjectId = account.id;
          params.busiSubjectId = this.currentRow.platformCompanyId
              ? this.currentRow.platformCompanyId
              : this.currentRow.payBankAccountId;
        } else {
          params.subjectType = 0;
          params.memName = account.name;
        }
        let payRes = await apiRequest("api/finance/", "cebBusiMem/queryMemList", params);
        if (
            payRes.status === 1 &&
            payRes.data.rows &&
            payRes.data.rows.length === 1 &&
            (isNotEmpty(this.currentRow.payBank) || type === 0)
        ) {
          this.currentRow.recBank = payRes.data.rows[0].busiSubjectName;
          this.currentRow.recBankOwn = payRes.data.rows[0].busiSubjectName;
          this.currentRow.recName = payRes.data.rows[0].memName;
          this.currentRow.recCompName = payRes.data.rows[0].busiSubjectName;
          this.currentRow.recAccount = payRes.data.rows[0].subAcc;
        } else {
          this.currentRow.recBank = null;
          this.currentRow.recBankOwn = null;
          this.currentRow.recName = null;
          this.currentRow.recAccount = null;
          this.currentRow.recCompName = null;
        }
      }
    },
    async chooseOrderEvent(amountList, usedAmount, type) {
      // 选择订单自动带入数据
      this.isShowCollectionOrder = false;
      this.$refs[this.tableName].clearValidate("ordersNum");

      this.currentRow.usedAmount = usedAmount;
      this.currentRow.ordersList = amountList;
      if (amountList.length > 0) {
        this.currentRow.ordersNum = amountList[0].ordersNum;
        if (type === 'sub') {
          this.currentRow.isSub = true;
          this.currentRow.salesMan = amountList[0].salesMan;
          this.currentRow.salesManId = amountList[0].salesManId;
          this.currentRow.ordersVersion = 4;
        } else {
          this.currentRow.isSub = false;
          this.currentRow.clientName = amountList[0].sellerName;
          this.currentRow.clientId = amountList[0].sellerId;
        }
      } else {
        this.currentRow.ordersNum = "";
      }
    },
    async chooseOrderOnlineEvent(amountList, usedAmount, type) {
      this.isShowChooseOrder = false;
      this.$refs[this.tableName].clearValidate("ordersNum");
      this.currentRow.ordersList = amountList;
      this.currentRow.ordersNum = amountList[0].ordersNum;
      this.currentRow.clientName = amountList[0].sellerName;
      // this.currentRow.salesMan = amountList[0].salesMan;
      // this.currentRow.rateManage = amountList[0].rateManage;
      // 选择订单重置银行信息
      if (type === 'sub') {
        this.currentRow.isSub = true;
        this.currentRow.salesMan = amountList[0].salesMan;
        this.currentRow.salesManId = amountList[0].salesManId;
        this.currentRow.payAmount = amountList[0].settlementAmount;
        this.currentRow.ordersVersion = 4;
      } else {
        this.currentRow.payBank = null;
        this.currentRow.payBankOwn = null;
        this.currentRow.paymentsName = null;
        this.currentRow.payAccount = null;
        this.currentRow.recBank = null;
        this.currentRow.recBankOwn = null;
        this.currentRow.recName = null;
        this.currentRow.recAccount = null;
        this.currentRow.payCompName = null;
        this.currentRow.recCompName = null;

        this.currentRow.isSub = false;
        // 线上支付自动带入银行账户信息
        if (this.payType === 0) {
          console.log("线上支付自动带入银行账户信息", this.currentRow);
          let path = "api/finance/";
          let action = "cebBusiMem/queryMemList";
          let params = {};
          params.busiSubjectId = amountList[0].platformCompanyId;
          if (isNotEmpty(this.currentRow.ordersList)) {
            params.subjectId = amountList[0].platformCompanyId;
          }
          switch (amountList[0].paymentType) {
            case 1:
              params.subjectType = 1;
              break;
            case 2:
              params.subjectType = 0;
              break;
          }
          let res = await apiRequest(path, action, params);
          if (res.status === 1) {
            if (res.data.rows.length < 1) {
              this.$XModal.message({
                message: "付款企业或者个人未绑定子账户，请先绑定子账户",
              });
              return;
            } else {
              let arr = res.data.rows.filter((item) => {
                return item.busiSubjectName == this.currentRow.compName;
              });
              if (arr && arr.length > 0 && amountList[0].paymentType === 2) {
                // this.currentRow.payBank = "光大银行";
                this.currentRow.payBank = arr[0].busiSubjectName;
                this.currentRow.payBankOwn = arr[0].busiSubjectName;
                this.currentRow.paymentsName = arr[0].memName;
                this.currentRow.payCompName = arr[0].busiSubjectName;
                this.currentRow.payAccount = arr[0].subAcc;
              } else {
                this.currentRow.payBank = null;
                this.currentRow.payBankOwn = null;
                this.currentRow.paymentsName = null;
                this.currentRow.payCompName = null;
                this.currentRow.payAccount = null;
              }
            }
          }

          if (isNotEmpty(this.currentRow.ordersList)) {
            params.subjectId = this.currentRow.ordersList[0].sellerId;
          }
          switch (amountList[0].paymentType) {
            case 1:
              params.subjectType = 0;
              break;
            case 2:
              params.subjectType = 1;
              break;
          }

          let redRes = await apiRequest(path, action, params);
          if (redRes.status === 1) {
            if (redRes.data.rows.length < 1) {
              this.$XModal.message({
                message: "收款企业或者个人未绑定子账户，请先绑定子账户",
              });
              return;
            } else {
              let arr = redRes.data.rows.filter((item) => {
                return item.busiSubjectName == this.currentRow.compName;
              });
              if (arr && arr.length > 0 && amountList[0].paymentType === 2) {
                // this.currentRow.recBank = "光大银行";
                this.currentRow.recBank = arr[0].busiSubjectName;
                this.currentRow.recBankOwn = arr[0].busiSubjectName;
                this.currentRow.recName = arr[0].memName;
                this.currentRow.recAccount = arr[0].subAcc;
                this.currentRow.recCompName = arr[0].busiSubjectName;
              } else {
                this.currentRow.recBank = null;
                this.currentRow.recBankOwn = null;
                this.currentRow.recName = null;
                this.currentRow.recAccount = null;
                this.currentRow.recCompName = null;
              }
            }
          }
        }
      }
    },
    async chooseFinanceAccount(account, index, field, type) {
      // console.log(account, '选择付款account');
      this.isShowFinance = false;
      let tableData = this.$refs[this.tableName].getTableData().fullData;

      if (tableData[index]) {
        if (field == "paymentsName") {
          // tableData[index].payBank = "光大银行";
          tableData[index].payBank = account.busiSubjectName;
          tableData[index].payBankOwn = account.busiSubjectName;
          tableData[index].paymentsName = account.memName;
          tableData[index].payAccount = account.subAcc;
          tableData[index].payCompName = account.busiSubjectName;
          tableData[index].payBankAccountId = account.busiSubjectId;
          tableData[index].paymentsType = type;
          // 自动带数据
          if (tableData[index].clientName && tableData[index].recNameType !== 0) {
            //选择完“付款账户”后自动带出“付款账号和账户所属公司”，同时判断如果“客户名称”字段有选客户且存在付款方所属公司的子账户，
            //右边的“收款账户，收款账号，账户所属公司”自动带入（一个客户对应的同一个所属公司的子账户只有一个），支持修改
            let payRes = await apiRequest("api/finance/", "cebBusiMem/queryMemList", {
              orderBy: 2,
              page: 1,
              rows: 10,
              subjectType: 1,
              subjectId: tableData[index].recAccountObj?.id,
              busiSubjectId: account.busiSubjectId,
            });
            if (payRes.status === 1 && payRes.data.rows && payRes.data.rows.length === 1) {
              tableData[index].recBank = payRes.data.rows[0].busiSubjectName;
              tableData[index].recBankOwn = payRes.data.rows[0].busiSubjectName;
              tableData[index].recName = payRes.data.rows[0].memName;
              tableData[index].recCompName = payRes.data.rows[0].busiSubjectName;
              tableData[index].recAccount = payRes.data.rows[0].subAcc;
            } else {
              tableData[index].recBank = null;
              tableData[index].recBankOwn = null;
              tableData[index].recName = null;
              tableData[index].recAccount = null;
              tableData[index].recCompName = null;
            }
          }
        } else {
          // 清空数据
          if (tableData[index].recName !== account.memName) {
            tableData[index].isDraw = 0;
            tableData[index].drawBank = null;
            tableData[index].drawAccount = null;
          }
          // tableData[index].recBank = "光大银行";
          tableData[index].recBank = account.busiSubjectName;
          tableData[index].recBankOwn = account.busiSubjectName;
          tableData[index].recName = account.memName;
          tableData[index].recAccount = account.subAcc;
          tableData[index].recCompName = account.busiSubjectName;
        }
      }
    },
    openBindAccountModal(row, index) {
      if (isEmpty(row.recName)) {
        this.$XModal.message({message: "请先选择收款人"});
        return;
      }
      this.isShowBindAccount = true;
      this.$nextTick(() => {
        this.$refs.BindAccount.init(row, index);
      });
    },
    chooseBindAccount(account, index) {
      this.isShowBindAccount = false;
      let tableData = this.$refs[this.tableName].getTableData().fullData;
      tableData[index].drawBank = account.bindOpenBankName;
      tableData[index].drawAccount = account.bindAccNum;
      tableData[index].isDrawAccountNew = 0;
      tableData[index].drawOpenOrgNum = account.bindOpenOrgNum;
    },
    async openBankAccountModal(row, index, field) {
      if (isEmpty(this.formData.compName)) {
        this.$XModal.message({status: "error", message: "请先选择所属公司"});
        return
      }

      // if(field === 'recName'){
      //   if (isEmpty(row.clientName)) {
      //     this.$XModal.message({status: "error", message: "请先选择客户名称"});
      //     return
      //   }
      // }
      // console.log(row, "ddddd");
      if (
          (isEmpty(row.compName) || (field === "recName" && isEmpty(row.clientName)))) {
        // await this.$refs[this.tableName].clearValidate();
        await this.$refs[this.tableName].scrollTo(0, 0);
        setTimeout(async () => {
          await this.$refs[this.tableName].validate(row, (err) => {
          });
        }, 100);
        // await this.$refs[this.tableName].validate(row, (err) => {});
        return;
      }

      let tableData = this.$refs[this.tableName].getTableData().tableData;
      if (tableData[index]) {
        // console.log(tableData[index]);
        // debugger
        let type = this.payType;

        this.currentChooseColumn = field;
        if (type === 1) {
          this.isShowBankAccountModal = true;
          this.$nextTick(() => {
            this.$refs.bankAccountModal.init(type, index, field, row);
          });
        } else {
          this.isShowFinance = true;
          let account = field === "paymentsName" ? row.payAccountObj : row.recAccountObj;
          let initType = field === "paymentsName" ? row.compNameType : row.recNameType;
          this.$nextTick(() => {
            this.$refs.financeAccount.init(row, index, field, initType, account, 'payProdure');
          });
        }
      } else {
        this.$XModal.message({message: "请先选择订单"});
      }
    },
    chooseBankAccount(bankAccount, index) {
      let tableData = this.$refs[this.tableName].getTableData().tableData;
      if (this.currentChooseColumn == "paymentsName") {
        if (bankAccount.rowType == "user") {
          tableData[index].payBank = bankAccount.openBankName;
          tableData[index].payBankOwn = bankAccount.openBankName;
        } else {
          tableData[index].payBank = bankAccount.bankName;
          tableData[index].payBankOwn = bankAccount.bankName;
        }
        tableData[index].paymentsName = bankAccount.accountName;
        tableData[index].payAccount = bankAccount.accountNum;
        tableData[index].payCompName = bankAccount.busiSubjectName;
      } else {
        if (bankAccount.rowType == "user") {
          tableData[index].recBank = bankAccount.openBankName;
          tableData[index].recBankOwn = bankAccount.openBankName;
        } else {
          tableData[index].recBank = bankAccount.bankName;
          tableData[index].recBankOwn = bankAccount.bankName;
        }
        tableData[index].recName = bankAccount.accountName;
        tableData[index].recAccount = bankAccount.accountNum;
        tableData[index].recCompName = bankAccount.busiSubjectName;
      }
      this.isShowBankAccountModal = false;
      this.$refs[this.tableName].clearValidate(this.currentChooseColumn);
    },
    closeBankAccount() {
      this.isShowBankAccountModal = false;
    },
    inputPayAmountEvent(row) {
      if (isNotEmpty(row.payAmount) && row.ordersNum == " ") {
        row.ordersNum = null;
      }
      if (this.payType === 0) {
        if (isNaN(parseFloat(row.payAmount))) {
          row.payAmount = null;
        }
      }

      //从订单进入创建,  没有关联金额, 输入付款金额保存到关联金额
      this.$refs[this.tableName].clearValidate("payAmount");
      this.updateFooterEvent();
    },
    async validEvent() {
      // return new Promise((resolve, reject) => {
      //    const errMap = this.$refs[this.tableName].validate( resolve(true)).catch((errMap) => reject(errMap));

      // })
      const errMap = await this.$refs[this.tableName].validate().catch((errMap) => errMap);
      return errMap ? false : true;
    },
    uploadFile() {
      alert("上传附件");
    },
    async submitEvent(type = "new") {
      this.isSubmit = true;
      this.isChangeType = true;
      let table = this.$refs[this.tableName].getTableData();
      let errMsgRow = "";
      let isErr = false;
      // let isSameCompMsgRow = "";
      // let isSameCompErr = false;
      let isNoPayCompErr = false;
      let isNoCompMsgRow = "";
      let isNoSameCompPayRow = "";
      let isNoSameCompPayErr = false;
      // 托运人订单线下支付 请求地址
      this.$refs[this.tableName].updateStatus();
      if (type === "new") {
        // let sts = false;
        // table.fullData.forEach( (item) => {
        //   let errMap = await this.$refs[this.tableName].validate(item).catch((errMap) => errMap);
        //   if (errMap) {
        //     debugger
        //     sts = true;
        //   }
        // });

        // console.log(sts);
        let tableData = table.fullData;
        if (isEmpty(this.formData.compName)) {
          this.$XModal.message({status: "error", message: "请先选择所属公司"});
          return
        }
        if (isEmpty(this.formData.isQqPush)) {
          this.$XModal.message({status: "error", message: "请选择同步企企"});
          return
        }
        let sts = await this.$refs[this.tableName].validate(tableData).catch((errMap) => errMap);
        if (sts) {
          this.$XModal.message({status: "error", message: "校验不通过！"});
          return;
        }

        table.fullData.forEach((item, index) => {
          if (item.payAccount == item.recAccount) {
            isErr = true;
            errMsgRow += `${index + 1},`;
          }
          // console.log(item, this.bankInfo);
          // debugger
          if (item.payBankOwn != item.recBankOwn && (!this.payBankKey.includes(item.payBankOwn) || !this.bankInfo[item.payBankOwn].includes(item.recBankOwn))) {
            isNoPayCompErr = true;
            isNoCompMsgRow += `${index + 1},`;
          }
          if (item.payBankOwn != item.recBankOwn) {
            // 所属公司不一致
            // 不可以跨商户
            // if (
            //   !this.payBankKey.includes(item.payBankOwn) ||
            //   !this.bankInfo[item.payBankOwn].includes(item.recBankOwn)
            // ) {
            //   isSameCompErr = true;
            //   isSameCompMsgRow += `${index + 1},`;
            // }
            // 可以跨商户
            if (
                this.payBankKey.includes(item.payBankOwn) &&
                this.bankInfo[item.payBankOwn].includes(item.recBankOwn)
            ) {
              isNoSameCompPayErr = true;
              isNoSameCompPayRow += `${index + 1},`;
            }
          }
        });
        if (isNoPayCompErr && this.payType === 0) {
          // let errrow = isNoPayCompErr ? isNoCompMsgRow : isSameCompMsgRow;
          this.$XModal.message({
            message: `序号${isNoCompMsgRow}未开通对应公司跨商户交易`,
          });
          return;
        }
        if (isErr && this.payType === 0) {
          this.$XModal.message({
            message: `序号${errMsgRow}付款人与收款人子账户不能一致`,
          });
          return;
        }
      }
      // 此段代码暂时开始  后期注释
      // if (isSameCompErr && this.payType === 0) {
      //   this.$XModal.message({
      //     message: `序号${isSameCompMsgRow}付款人与收款人所属公司不一致`,
      //   });
      //   return;
      // }

      if (this.payType === 0) {
        let map = {};
        let check = false;

        table.fullData.some(i => {
          if (map[i.clientName]) {
            let value = map[i.clientName];
            if (value.clientName === i.clientName && value.payAmount === i.payAmount) {
              this.$XModal.message({
                message: '同一客户存在相同金额，请分开提交流程',
              });
              check = true;
              return true;
            }
          } else {
            map[i.clientName] = i;
          }
        })

        if (check) return;
      }

      let rows;
      let outParamsObj = {};
      if (this.payType === 1) {
        rows = [];
        table.fullData.forEach((item) => {
          let row = {};
          row.addTime = item.addTime
              ? this.$utils.timestamp(this.$utils.toStringDate(item.addTime))
              : null;
          row.drawAccount = item.drawAccount;
          row.drawBank = item.drawBank;
          row.clientName = item.clientName;
          row.clientId = item.clientId;
          // drawName, fcsSerialNum
          row.fileUuidList = item.fileUuidList;
          row.isDraw = item.isDraw;
          row.note = item.note;
          row.payAccount = item.payAccount;
          row.payAmount = item.payAmount;
          row.payBank = item.payBank;
          row.paymentsName = item.paymentsName;
          row.payBankCode = item.payBankCode;
          row.paymentType = 2;
          row.platformCompanyId = item.platformCompanyId;
          row.rateManage = item.rateManage;
          row.recAccount = item.recAccount;
          row.recName = item.recName;
          row.recBank = item.recBank;
          row.salesMan = item.salesMan;
          row.compName = item.compName;
          row.clientRegisiterNum = item.clientRegisiterNum;
          row.moneyType = item.moneyType;

          let ordersAmountList = [];
          let usedAmount = 0;

          let orderPayAmount = item.payAmount;
          if (isNotEmpty(item.ordersList)) {
            item.ordersList.forEach((item) => {
              let obj = {
                aboutAmount: this.fromOrigin === "order" ? orderPayAmount : item.aboutAmount,
                ordersNum: item.ordersNum,
              };
              ordersAmountList.push(obj);
              usedAmount += item.aboutAmount;
            });
          }
          row.ordersAmountList = ordersAmountList;
          row.usedAmount = item.ordersList && item.ordersList.length > 0 ? usedAmount : 0;
          row.unusedAmount = parseFloat(row.payAmount) - row.usedAmount;

          if (this.isAcc) {
            row.tradeDetailId = this.accData.id;
          }
          rows.push(row);
        });
        outParamsObj.paymentList = rows;
        outParamsObj.payType = 0; // 1线下
        outParamsObj.isQqPush = this.formData.isQqPush;
      } else {
        // 线上支付  参数重传
        rows = {};
        rows.title = this.formData.title;
        rows.applyTime = this.$utils.timestamp(this.$utils.toStringDate(this.formData.applyTime));
        rows.detailList = [];
        table.fullData.forEach((item) => {
          let paramesObj = {};
          paramesObj.paymentType = 2; // 付款2 收款1
          paramesObj.clientName = item.clientName;
          paramesObj.clientId = item.clientId;
          paramesObj.compName = item.compName;
          // paramesObj.ownName = item.compName;
          paramesObj.note = item.note;
          paramesObj.payAccount = item.payAccount;
          paramesObj.payBankOwn = item.payBankOwn;
          paramesObj.payAmount = item.payAmount;
          paramesObj.paymentsName = item.paymentsName;
          paramesObj.platformCompanyId = item.platformCompanyId;
          paramesObj.recAccount = item.recAccount;
          paramesObj.recBankOwn = item.recBankOwn;
          paramesObj.recName = item.recName;
          paramesObj.salesMan = item.salesMan;
          paramesObj.salesManId = item.salesManId;
          paramesObj.fileUuidList = item.fileUuidList;
          paramesObj.rateManage = item.rateManage;
          paramesObj.isDraw = item.isDraw;
          paramesObj.drawBank = item.drawBank;
          paramesObj.isDrawAccountNew = item.isDrawAccountNew;
          paramesObj.drawAccount = item.drawAccount;
          paramesObj.drawOpenOrgNum = item.drawOpenOrgNum;
          paramesObj.moneyType = item.moneyType;

          if (item.ordersList && item.ordersList.length > 0) {
            paramesObj.ordersList = item.ordersList.map((i) => {
              return {aboutAmount: item.payAmount, ordersNum: i.ordersNum};
            });
          }
          // console.log(paramesObj);
          // debugger;
          rows.detailList.push(paramesObj);
          // if (
          //   item.ordersBuyerAmountList &&
          //   item.ordersBuyerAmountList.length > 0
          // ) {
          //   paramesObj.ordersList = item.ordersBuyerAmountList;
          // } else if (
          //   item.ordersSellerAmountList &&
          //   item.ordersSellerAmountList.length > 0
          // ) {
          //   paramesObj.ordersList = item.ordersSellerAmountList;
          // } else if (
          //   item.ordersSellerLv2sAmountList &&
          //   item.ordersSellerLv2sAmountList.length > 0
          // ) {
          //   paramesObj.ordersList = item.ordersSellerLv2sAmountList;
          // }
          // if (paramesObj.ordersList && paramesObj.ordersList.length > 0) {
          //   paramesObj.ordersList = paramesObj.ordersList.map((i) => {
          //     return Object.assign(i, {aboutAmount: item.payAmount});
          //   });
          // }
        });
        outParamsObj.onlinePaymentVo = rows;
        outParamsObj.payType = 1; // 1线上
      }
      // showLoading();
      let that = this;
      setTimeout(() => {
        let uploadtable = this.uploadData;
        outParamsObj.attachFile = uploadtable[0].fileUuidList;
        outParamsObj.applyTime = this.$utils.timestamp(
            this.$utils.toStringDate(this.formData.applyTime)
        );
        outParamsObj.instanceName = this.formData.instanceName;
        outParamsObj.instanceNum = this.formData.instanceNum;
        outParamsObj.applyUserId = this.formData.applyUserId;
        outParamsObj.leaderId = this.formData.leaderId;
        outParamsObj.managerId = this.formData.managerId;
        outParamsObj.reterenceId = this.formData.reterenceId;
        outParamsObj.reterenceName = this.formData.reterence;
        outParamsObj.flowTempletId = this.flowTempletId;
        outParamsObj.isQqPush = this.formData.isQqPush;
        if (this.isInitBySave) {
          outParamsObj.id = this.initBySaveId;
        }

        if (type === "new") {
          if (this.payType === 0) {
            if (isNoSameCompPayErr) {
              this.$XModal
                  .confirm(
                      `序号${isNoSameCompPayRow}付款人与收款人所属公司不一致,确认继续发起跨商户付款`
                  )
                  .then((type) => {
                    if (type === "confirm") {
                      showLoading();
                      $api.flowInstance.saveFlowForPaymentSellerTwo
                          .POST({
                            data: outParamsObj,
                          })
                          .then((res) => {
                            if (res) {
                              hideLoading();
                              this.$emit("init");
                            }
                            if (res.status === 1) {
                              let mesTxt = this.payType === 1 ? "提交成功" : "提交成功，待银行处理";
                              this.$XModal.message({
                                status: "success",
                                message: mesTxt,
                              });
                              this.tableData = [];
                              this.$emit("close");
                              window.close();
                            } else if (res.status == 0) {
                              showFailMsgList(res.data);
                            } else {
                              that.$XModal.alert({
                                message: res.message ? res.message : "接口异常",
                                status: "error",
                              });
                            }
                          });
                    }
                  });
            } else {
              showLoading();
              $api.flowInstance.saveFlowForPaymentSellerTwo
                  .POST({
                    data: outParamsObj,
                  })
                  .then((res) => {
                    if (res.status === 1) {
                      hideLoading();
                      let mesTxt = this.payType === 1 ? "提交成功" : "提交成功，待银行处理";
                      this.$XModal.message({
                        status: "success",
                        message: mesTxt,
                      });
                      this.tableData = [];
                      this.$emit("close");
                      window.close();
                    } else if (res.status == 0) {
                      hideLoading();
                      showFailMsgList(res.data);
                    } else {
                      hideLoading();
                      that.$XModal.alert({
                        message: res.message ? res.message : "接口异常",
                        status: "error",
                      });
                    }
                  });
            }
          } else {
            showLoading();
            $api.flowInstance.saveFlowForPaymentSellerTwo
                .POST({
                  data: outParamsObj,
                })
                .then((res) => {
                  if (res) {
                    hideLoading();
                    this.$emit("init");
                  }
                  if (res.status === 1) {
                    let mesTxt = this.payType === 1 ? "提交成功" : "提交成功，待银行处理";
                    this.$XModal.message({status: "success", message: mesTxt});
                    this.tableData = [];
                    this.$emit("close");
                    window.close();
                  } else if (res.status == 0) {
                    showFailMsgList(res.data);
                  } else {
                    that.$XModal.alert({
                      message: res.message ? res.message : "接口异常",
                      status: "error",
                    });
                  }
                });
          }
        } else {
          $api.flowInstance.saveDraftFlowForPaymentSellerTwo
              .POST({
                data: outParamsObj,
              })
              .then((res) => {
                if (res) {
                  hideLoading();
                  this.$emit("init");
                }
                if (res.status === 1) {
                  let mesTxt = "保存成功";
                  this.$XModal.message({status: "success", message: mesTxt});
                  this.tableData = [];
                  this.$emit("close");
                  window.close();
                } else if (res.status == 0) {
                  showFailMsgList(res.data);
                } else {
                  that.$XModal.alert({
                    message: res.message ? res.message : "接口异常",
                    status: "error",
                  });
                }
              });
        }
      }, 100);
    },
    footerCellClassName({$rowIndex, column, columnIndex}) {
      return "footer-cell";
    },
    footerMethod({columns, data}) {
      return paymentFooter({columns, data, rowName: "合计"});
    },
    updateFooterEvent() {
      this.$refs[this.tableName].updateFooter();
    },
    async initPlatCompMap() {
      if (JSON.stringify(this.platformCompMap) === '{}') {
        let res = await $api.department.get("listCompany");
        let map = {};
        res.data.rows.forEach((item) => {
          map[item.name] = item.id;
        });
        this.platformCompMap = map;
      }
    },
  },
};
</script>

<style>
.pay-modal-header .vxe-form .vxe-form--item {
  padding: 0;
}

.pay-modal-header .vxe-form .vxe-form--item:first-child .vxe-input--inner,
.pay-modal-header
.vxe-form
.vxe-form--item:first-child
.vxe-input:not(.is--disabled).is--active
.vxe-input--inner,
.pay-modal-header .vxe-form .vxe-form--item:first-child .vxe-form--item-title {
  border-bottom: none;
}

.pay-modal-header .vxe-form--item-title {
  height: 30px;
  line-height: 30px;
  background: #fafafa;
  border: 1px solid #f2f1f1;
}

.pay-modal-header .vxe-input,
.pay-modal-header .vxe-form--item-content,
.pay-modal-header .ivu-select {
  height: 30px;
}

.pay-modal-header .vxe-input--inner {
  border-radius: 0;
  border: 1px solid #f2f1f1;
}

.pay-modal-header .vxe-input:not(.is--disabled).is--active .vxe-input--inner {
  border: 1px solid #f2f1f1;
}

.pay-modal-header .ivu-select-single .ivu-select-selection,
.pay-modal-header .ivu-input {
  height: 30px;
  border-radius: 0px;
  border: 1px solid #f2f1f1;
  box-shadow: none;
}

.pay-modal-header .ivu-select-single .ivu-select-selection .ivu-select-selected-value,
.pay-modal-header .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
  height: 30px;
  line-height: 30px;
}

.pay-modal-main {
  padding-top: 20px;
}

/*********************** */
</style>
<style scoped>
/deep/ .table-style.cur-table-style .vxe-header--column .vxe-cell {
  height: 30px;
}

/deep/ .table-style.cur-table-style .vxe-input.switch-input .vxe-input--inner {
  padding-right: 60px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/deep/ .table-style.cur-table-style .vxe-input.switch-input .vxe-input--suffix {
  margin-right: 10px;
  color: #7f7f7f;
}

/deep/ .table-style.cur-table-style .vxe-input.switch-input .vxe-input--suffix .ivu-switch {
  margin-right: 10px;
}

/deep/ .table-style.cur-table-style
.vxe-input.switch-input
.vxe-input--suffix
.ivu-switch
.ivu-switch-inner::before {
  content: "手输";
  position: absolute;
  left: 0;
  top: 0;
  color: #fff;
  z-index: 99;
}

.column-title-em {
  display: flex;
  flex-direction: column;
  line-height: 1;

  text-align: center;
}

.column-title-em em {
  margin-top: 3px;
  font-size: 12px;
}

/deep/ .table-style.cur-table-style
.vxe-input.switch-input
.vxe-input--inner::-webkit-input-placeholder {
  color: #adadad;
  text-indent: 45px;
}

.my-dropdown1 {
  height: 200px;
  overflow: auto;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
}

.list-item1 {
  padding: 5px;
}

.list-item1:hover {
  background-color: #f5f7fa;
}

.window {
  padding: 20px;
  background: #ffffff;
  height: 100vh;
}

.add-box .produre .vxe-input, .add-box .produre .vxe-select, .add-box .produre .ivu-cascader .ivu-input {
  height: 30px;
}

.produre .vxe-select >>> .vxe-input {
  height: 30px;
}

.produre >>> .vxe-body--column {
  height: 30px !important;
}

.produre >>> .vxe-body--column:not(.col--ellipsis), .produre >>> .vxe-footer--column:not(.col--ellipsis), .produre >>> .vxe-header--column:not(.col--ellipsis) {
  padding: 3px 0;
}

.footer-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  overflow: hidden;
  vertical-align: middle;
  background-color: #fff;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 15px;
  display: flex;
  justify-content: flex-end;
}

.left10 {
  margin-left: 10px;
}
</style>
